var domestic_colour_class = 'domestic_colour';
var international_colour_class = 'international_colour';
var fast_facts_dom_int_toggle_container = $('.ff_toggle_options');
var fast_facts_bottom_container = $('.fast_facts_bottom_container');
var fast_facts_int_option = fast_facts_dom_int_toggle_container.find('#ff_modal_int_option');
var fast_facts_dom_option = fast_facts_dom_int_toggle_container.find('#ff_modal_dom_option');
var toggle_button = $('.ff_toggle_label, .ff_toggle_icon');

var course_id_value = $('#course_id_input').val();
var course_name_value = $('#course_name_input').val();
var course_url_value = $('#course_url_input').val();

var save_course_label = $('.ff_save_course_label');
var save_course_icon = $('.ff_save_course_icon');
//Because I don't wanna miss these in a race condition some-how
var ff_course_page_cookie_name = 'ksdf8rmdfg9ksd934gmngLFQjhas08jsd7klsfHGFDAud';

var before_fade_delay = 500;

var jotforms_to_update = [];


function addQueryStringToPrepops(){
    var params = getAllQueryStringParams();
    for(var jotform_index = 0 ; jotform_index < jotforms_to_update.length; jotform_index++){
        var props = jotforms_to_update[jotform_index].props;
        for(var param_name in params){
            if(jotforms_to_update[jotform_index].utm_update && countsAsUTMField(param_name)){
                //if the form is set to receive saved utm_ fields *AND* the parameter is a utm_ param, it's set from the saved info
                //so we do nothing here
            }else{
                props[param_name] = params[param_name];
            }
        }
    }
}

function fixJotformPrepops(target){
    addQueryStringToPrepops();
	for(var index = 0 ; index < jotforms_to_update.length; index++)
	{
		var props = jotforms_to_update[index].props;
		var iframe = jotforms_to_update[index].iframe;
		if(props)
		{
			//TODO(Christof): make this work for drop downs (also check select elements) and check boxes/radio buttons? for now we really only care about the hidden fields so this is fine, but...
    		iframe.contents().find("input").each(function(index, element){
    			var found = false;
    			for(var prop in props)
   				{
   					var input_element_name = $(element).prop('name');
					if(input_element_name.indexOf(prop) != -1){
						if(input_element_name === prop || prop === input_element_name.substring(input_element_name.indexOf("_") + 1)) {
                            var NewValue = decodeURIComponent(props[prop]);
                            $(element).val(NewValue);
                            found = true;
                            break;
						}
					}   				
   				}
    			if(!found)
				{
    				//NOTE(Christof): since we are fixing the broken jotform prefiller, we need to clear any fields that aren't set
    				var value = element.getAttribute("value") || "";
    				$(element).val(value);
				}
    		});
		}
	}
}

function setupFastFactsTooltips() {
	//Handle tooltips for fastfacts
	var all_ff_tooltips = $(".fast_facts_tooltip_icon");
	var ff_tooltip_template = '<div class="tooltip ff_tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';

	all_ff_tooltips.on("click focus", function (e) { 
		e.preventDefault();
	    return false;
	});
	//Apply tooltip settings
	all_ff_tooltips.tooltip({animation: true, container: '.fast_facts_tooltip_icon',placement:'top',trigger:"click hover focus", template: ff_tooltip_template});
}
$(document).ready(function () {	
	var is_course_page = $('.course_pages').length > 0;
	if(is_course_page) {
		setupFastFactsTooltips();
	}
	
	//This polyfill adds nodeList.forEach(callback[, thisArg]) compatibility to all Browsers supporting ES5
	//See: https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Browser_Compatibility
	//This specifically relates to IE deciding that forEach on a nodelist is not a thing it wants to support
	if (window.NodeList && !NodeList.prototype.forEach) {
	    NodeList.prototype.forEach = function (callback, thisArg) {
	        thisArg = thisArg || window;
	        for (var i = 0; i < this.length; i++) {
	            callback.call(thisArg, this[i], i, this);
	        }
	    };
	}

	//JOTFORMS OBSERVER
	//We need to fix the height of the iframes for jotforms because the 3rd party code is setting the first form in the DOM to 0 height
	//because the second form is hidden...
	var observer = new MutationObserver(function(mutations) {
	    mutations.forEach(function(mutationRecord) {
	        var inlineStyleChanged = mutationRecord.target.attributes.style.nodeValue;
	        if(inlineStyleChanged.indexOf('height: 0px') > -1) {
	        	//fixJotformHeights();
	        }
	    });
	});

	var targets = document.querySelectorAll('.jotform-form iframe');
	//fixJotformHeights();
	if(targets.length > 0) {
		targets.forEach(function(targetRecord) {
	        observer.observe(targetRecord, { attributes : true, attributeOldValue: true,  attributeFilter : ['style'] });
	    });
	}

	//END JOTFORMS OBSERVER


	//ff dom int toggle clicked
	toggle_button.on("click", function () {
		openFastFactsModal();

	    return false;
	});
	//ff_save_course_button
	//TODO: Check the cookies as well, maybe wait for response before changing the UI?
	$('.ff_save_course').on("click", function () {
		if($(this).hasClass('saved')) {
			//unsave course
			updateFastFactsSaveCourseUI('unsave');
			var result = setCookie(ff_course_page_cookie_name, course_id_value, 90, 'delete');
			//todo: add check here to check the value of the result and see if the cookie was properly deleted or saved
			console.log('attempted to UN-save cookie, result: ',result);
			updateSavedCourseListUI(course_id_value, 'unsave');
		}
		else {
			//save course
			updateFastFactsSaveCourseUI('save');
			var result = setCookie(ff_course_page_cookie_name, course_id_value, 90, 'append');
			console.log('attempted to save cookie, result: ',result);
			//todo: add check here to check the value of the result and see if the cookie was properly deleted or saved
			updateSavedCourseListUI(course_id_value, 'save');
		}
	    return false;
	});

	function openFastFactsModal() {
	    $('.ff_modal_overlay , .ff_modal').fadeIn(function() {
	    	//Focus the currently selected item
	    	$('.option_container:not(.selected) .ff_switch_button').focus();	    	
	    });

	    //Bind the escape key when the modal is opened so it can close the modal
	    //NOTE: REMEMBER TO UNBIND THIS "closeModalSwitchContent()" DOES THIS
	    //NOTE: If this does not work in all browsers, extend it here
	    $(document).on('keydown.ff_modal_escape',function(e){
	        if(e.which==27)
	        {
	            closeModalSwitchContent('close');
	            
	        }
	    });
	    //Bind the document click event and use it's target to decide what to do
	    $(document).on('click.ff_modal', function(e) {
	        var click_target = $(e.target);
	        var option_container_clicked = click_target.closest('.option_container');
	        
	        if (!click_target.closest('.ff_modal').length) {
	        	closeModalSwitchContent('close');
	        	
	        } else if (option_container_clicked.prop('id') === 'ff_modal_dom_option'){
	        	if(!option_container_clicked.hasClass('selected')) {
	        		closeModalSwitchContent('dom');
	        	} else {
	        		closeModalSwitchContent('close');
	        	}
	        	
	        } else if (option_container_clicked.prop('id') === 'ff_modal_int_option'){
	        	if(!option_container_clicked.hasClass('selected')) {
	        		closeModalSwitchContent('int');
	        	} else {
	        		closeModalSwitchContent('close');
	        	}
	        	
	        } else {
	        	closeModalSwitchContent('close');
	        }
	    });

	}
	
	//Because there is some js preventing buttons doing their thing:
	$('.ff_switch_button').on("click", function () { 
		var closest_option_container = $(this).closest('.option_container');
		var id_of_option_clicked = $(this).prop('id');

		if(id_of_option_clicked === 'ff_modal_int_option_button') {
			if(!closest_option_container.hasClass('selected')) {
        		closeModalSwitchContent('int');
        	} else {
        		closeModalSwitchContent('close');
        	}
		} else if(id_of_option_clicked === 'ff_modal_dom_option_button') {
			if(!closest_option_container.hasClass('selected')) {
        		closeModalSwitchContent('dom');
        	} else {
        		closeModalSwitchContent('close');
        	}
		} else {
			console.log("something went wrong :(");
		}
		return false;
	});
	
	function closeModalSwitchContent(action) {
		var result = '';
        if(action === 'dom') {  
			updateDomIntContentUI('dom');
    		result = updateOrSetDomIntCookie('dom');
    		hideTooltip();
    		closeToolTip();
    		//console.log('attempt to set location cookie to domestic, result: ',result);
        	$('.ff_modal_overlay , .ff_modal').delay(before_fade_delay).fadeOut();
        } else if (action === 'int') {    
			updateDomIntContentUI('int');
    		result = updateOrSetDomIntCookie('int');
    		hideTooltip();
    		closeToolTip();
    		//console.log('attempt to set location cookie to international, result: ',result);
        	$('.ff_modal_overlay , .ff_modal').delay(before_fade_delay).fadeOut();
            
        } else if (action === 'close') {            	
        	$('.ff_modal_overlay , .ff_modal').fadeOut();
        } else {
        	$('.ff_modal_overlay , .ff_modal').fadeOut();
            
        }
        //Unbind events
        $(document).off('click.ff_modal');
        $(document).off('keydown.ff_modal_escape');
    	return false;
    }

	
	
	//Applies some styles to all jotforms to fix an issue with 3rd party code
	function fixJotformHeights() {
		 $('.jotform-form iframe').css('height', '');
    	return false;
    }
	
	

});

//Accepts an argument of "int" or "dom" to update just the domestic and international content of the fast facts UI.
function updateFastFactsUI(action) {
	
    if(action === 'dom') {            	
    	fast_facts_dom_int_toggle_container.find('.ff_toggle_label').addClass(domestic_colour_class).removeClass(international_colour_class);
		fast_facts_bottom_container.addClass(domestic_colour_class).removeClass(international_colour_class);
		fast_facts_dom_option.addClass('selected');
		fast_facts_int_option.removeClass('selected');
    } else if (action === 'int') {            	
    	fast_facts_dom_int_toggle_container.find('.ff_toggle_label').removeClass(domestic_colour_class).addClass(international_colour_class);
		fast_facts_bottom_container.removeClass(domestic_colour_class).addClass(international_colour_class);
		fast_facts_dom_option.removeClass('selected');
		fast_facts_int_option.addClass('selected');
    } else {
    	console.log('something went wrong :(');
    }
    
	//Check cookies and update the save course buttons in the fast facts component
	var all_saved_courses = getCookie(ff_course_page_cookie_name);
	if(all_saved_courses && all_saved_courses.split(',').indexOf(course_id_value) > -1) {
		updateFastFactsSaveCourseUI('save');
	} else {
		updateFastFactsSaveCourseUI('unsave');
	}
            
	return false;
}


//Updates just the UI of the fast facts component
//Accepts a string "action" with a value of "save" or "unsave"
function updateFastFactsSaveCourseUI(action) {
	
	if(action === 'unsave' || action === 'delete') {
		//Unsaved
		save_course_label.removeClass('saved');
		save_course_icon.removeClass('saved');
		
		save_course_label.text('Save course');
		save_course_icon.find('.save_course_heart_filled').hide();
		save_course_icon.find('.save_course_heart_empty').show();
		
	} else {
		//Saved
		save_course_label.addClass('saved');
		save_course_icon.addClass('saved');
		
		save_course_label.text('Unsave course');
		save_course_icon.find('.save_course_heart_empty').hide();
		save_course_icon.find('.save_course_heart_filled').show();
	}
	return false;
}

//Used for udating the course list when a course is saved via the Fast Facts component or when one is deleted
//Accepts a course id and also an action "save" or "unsave"
//TODO: Investigate if the function getCourseBookmark() can be used to get a list of valid courses (current version of this function uses purely front-end means - that way a course you are currently on will (almost) always be added to the list, even if it fails the back-end validation
function updateSavedCourseListUI(course_id, action) {
	
	//Check if there are other courses in the cookie, if yes, just remove the one unsaved, if no, show the thing in the place of none
	//Note: Using cookie because list html code is duplicated on the page...
	var all_saved_courses = getCookie(ff_course_page_cookie_name);
	var other_courses_saved = false;
	var course_row_in_lists = $('.courseBookmarkRow'+course_id);
	var menu_icon_container = $('.course_bookmark_menu_container');
	var course_bookmark_menu_list_container = $('.course_bookmark_menu_list_container');
	var course_bookmark_menu_list_container_empty = $('.course_bookmark_menu_list_container_empty');

	if(all_saved_courses && all_saved_courses.split(',').length >= 1) {
		other_courses_saved = true;
	} else {
		other_courses_saved = false;
	}
	
	if(action === 'unsave' || action === 'delete') {
		//Unsaved
		menu_icon_container.show();
		course_row_in_lists.slideUp(500, function() {
		    $(this).remove();
		    
		    if(other_courses_saved) {
				//course list has other things in it
				course_bookmark_menu_list_container.show();
				course_bookmark_menu_list_container_empty.hide();
			}
			else {
				//course list is empty
				course_bookmark_menu_list_container.hide();
				course_bookmark_menu_list_container_empty.show();
			}
		});
		
	} else {
		//Saved
		//Add course to list
		menu_icon_container.show();
		course_bookmark_menu_list_container_empty.hide();
		course_bookmark_menu_list_container.show();
		var course_to_add_to_lists = {"courseId": course_id,  "courseName": course_name_value,  "courseLink": course_url_value };
		//This line uses handlebars.js which is included in a clientlib so there is a chance there is a race condition??
		$(".courseBookmarkTarget").append(Handlebars.compile($("#courseBookmarkBaseMenu").html())(course_to_add_to_lists));
	}
	return false;
}
